import React, {useRef, useEffect} from 'react';
import './Style/Project.css';
import Helmet from "react-helmet";
import Typed from "typed.js";

const Project = () => {
    const chars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";

    const randomChar = () => chars[Math.floor(Math.random() * (chars.length - 1))],
        randomString = length => Array.from(Array(length)).map(randomChar).join("");

    const handleOnMove = e => {
        const rect = cardRef.current.getBoundingClientRect(),
            x = e.clientX - rect.left,
            y = e.clientY - rect.top;

        lettersRef.current.style.setProperty("--x", `${x}px`);
        lettersRef.current.style.setProperty("--y", `${y}px`);

        lettersRef.current.innerText = randomString(1500);
    }

    const cardRef = React.useRef(null);
    const lettersRef = React.useRef(null);

    React.useEffect(() => {
        cardRef.current.addEventListener('mousemove', handleOnMove);
        cardRef.current.addEventListener('touchmove', handleOnMove);

        return () => {
            cardRef.current.removeEventListener('mousemove', handleOnMove);
            cardRef.current.removeEventListener('touchmove', handleOnMove);
        }
    }, []);

    const wordRef = useRef(null);
    const animate = () => {
        const letters = wordRef.current.getElementsByTagName('span');
        const randomLetter = letters[Math.floor(Math.random() * letters.length)];
        randomLetter.style.opacity = 0.5;
        setTimeout(() => {
            randomLetter.style.opacity = 1;
        }, 500);
    };

    useEffect(() => {
        animate();
        setTimeout(animate, 500);
        setTimeout(animate, 1000);
        setTimeout(animate, 1500);
        setTimeout(animate, 1500);
    }, []);
    const el = useRef(null);

    useEffect(() => {
        const typed = new Typed(el.current, {
            strings: ["Fast", "Reliable", "Efficient", "Powerfull"], // Strings to display
            // Speed settings, try diffrent values untill you get good results
            startDelay: 300,
            typeSpeed: 50,
            backSpeed: 20,
            backDelay: 500,
            loop: true
        });

        // Destropying
        return () => {
            typed.destroy();
        };
    }, []);

    return (
        <div>
            <Helmet>
                <style>{'\n' +
                    'body {\n' +
                    '    background: #0b0e12;\n' +
                    '    height: 100vh;\n' +
                    '    display: flex;\n' +
                    '    justify-content: center;\n' +
                    '    overflow: hidden;\n' +
                    '    font-family: \'Noto Sans\', sans-serif;\n' +
                    '}\n' +
                    '\n' +
                    '* {\n' +
                    '    box-sizing: border-box;\n' +
                    '    margin: 0;\n' +
                    '    padding: 0;\n' +
                    '}'}</style>
            </Helmet>
            <a href="https://github.com/voaid-tk/">
        <div className="card-track">
            <div className="card-wrapper">
                <div className="card" ref={cardRef}>
                    <div className="card-image">
                        <img src="https://avatars.githubusercontent.com/u/120908792?s=400&u=cd8aabe6042c2a11f753e8ba14647355a44007c7&v=4" alt="avatar" />
                    </div>
                    <div className="card-gradient"></div>
                    <div className="card-letters" ref={lettersRef}></div>
                </div>

            </div>
        </div>
            </a>
        <div className="project-title">
            <div id="word" ref={wordRef}>
                <span>v</span>
                <span>o</span>
                <span>i</span>
                <span>a</span>
                <span>d</span>
            </div>
            <div className="content_p_1">
                <span ref={el}></span>
            </div>
        </div>

        </div>

);
}

export default Project;